import React from 'react';
import PropTypes from 'prop-types';
import Box from 'ui-box';
import Button from 'antd/es/button';
import Typography from 'antd/es/typography';
import Row from 'antd/es/row';
import Col from 'antd/es/col';
import { ReactComponent as CloseIconSvg } from '../../../assets/icons/medical-history/close-circle.svg';

const { Text, Title } = Typography

const styles = {
  email: {
    fontWeight: 700,
    fontSize: '12px',
    lineHeight: '20px',
    color: 'rgba(0, 0, 0, 0.854506)'
  },
  title: {
    fontSize: 16,
    fontWeight: 500,
    color: '#4A4A4A'
  },
  itemContainer: {
    display: "flex", 
    flexDirection: "row", 
    alignItems: "center", 
    justifyContent: 'space-between',
    padding: "8px 12px", 
    position: "static", 
    width: "100%", 
    height: "40px", 
    left: "0px", 
    top: "0px", 
    background: "#15A9E1", 
    borderRadius: "2px",
    marginBottom: 10
  },
  label: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    height: '3l2px',
    fontSize: '14px',
    paddingBottom: 8
  },
  labelItem: {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "24px",
    color: "#FFFFFF"
  },
  emptyData: {
    width: "100%", 
    height: "299px", 
    left: "0px", 
    top: "30px", 
    background: "#FFFFFF", 
    border: "1px solid #D9D9D9", 
    boxSizing: "border-box", 
    borderRadius: "2px",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  emptyText: {
    fontWeight: "300", 
    fontSize: "14px", 
    lineHeight: "24px", 
    textAlign: "center", 
    color: "#8C8C8C",
    margin: 0
  }
}

const MobileSharedWithList = ({ title, emptyTitle, list, onRemove }) => {
  const renderItem = (label, value) => {
    return (
      <Box style={styles.itemContainer}>
        <Text style={styles.labelItem}>{label}</Text>
        <CloseIconSvg onClick={() => onRemove(value)} />
      </Box>
    )
  }

  return (
    <section>
      <Col xs={24}>
        <label style={styles.label} title={title}>{title}</label>
      </Col>
      {
        list.length !== 0 && list.map((data) => renderItem(data.label, data.value))
      }
      {
        list.length === 0 && <Box style={styles.emptyData}><p style={styles.emptyText}>- {emptyTitle} -</p></Box>
      }
    </section>
  )
}

MobileSharedWithList.defaultProps = {
  title: 'Title',
  emptyTitle: 'Empty',
  list: []
}

MobileSharedWithList.propTypes = {
  title: PropTypes.string,
  emptyTitle: PropTypes.string,
  list: PropTypes.array,
  onRemove: PropTypes.func
}

export default MobileSharedWithList
